import React, { useState, useEffect } from 'react';
import { Card, Col, DatePicker, message, Row, Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import Item from '../../components/Form/Item';
import axios from '../../util/Api';
import moment from 'moment';
import DivisionForm from './DivisionForm';

const { Option } = Select;

const ProjectForm = (props) => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (formik.values.project.division) {
      fetchProjects();
    }
  }, [formik.values.project.division]);

  const fetchProjects = () => {
    setLoading(true);
    const url = `/project/options`;
    axios.get(url, { params: { sort: 'status', division: formik.values.project.division } }).then(({ data }) => {
      setProjects(data.projects);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat daftar proyek");
    });
  }

  return (
    <Card className="gx-card" title={props.title ? props.title : `Registrasi Akses Masuk Proyek`}>
      <Item name="Divisi Operasi" required>
        <DivisionForm />
      </Item>
      <Item name="Nama Proyek" required>
        <Select
          showSearch
          loading={loading}
          defaultValue={formik.values.project.id}
          onChange={(value) => formik.setFieldValue("project.id", value)}
          placeholder="Pilih proyek"
          optionFilterProp="label"
        >
          {projects.map((prj, key) => {
            return <Option value={prj.id} key={`project-${key}`} label={prj.name}>
              <div>{prj.name}</div>
              <div>
                {prj.code} - {prj.division.label}
              </div>
            </Option>
          })}
        </Select>
        <ErrorMessage component="div" name="project.id" className="gx-mt-2 gx-text-red" />
      </Item>
      <Item name="Tanggal Masuk" required>
        <DatePicker
          onChange={(value) => {
            formik.setFieldValue("project.start", value.format("YYYY-MM-DD"));
          }}
        />
        <ErrorMessage component="div" name="project.start" className="gx-mt-2 gx-text-red" />
      </Item>
      <Item name="Berakhir" required>
        <DatePicker
          onChange={(value) => {
            formik.setFieldValue("project.end", value.format("YYYY-MM-DD"));
          }}
          disabledDate={(current) => {
            return current && current < moment(new Date(formik.values.project.start)).endOf('day')
          }}
        />
        <ErrorMessage component="div" name="project.end" className="gx-mt-2 gx-text-red" />
      </Item>
    </Card>
  );
}

export default ProjectForm;